import { useState } from "react";
import { DatabaseZap, RotateCcw, Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";

const CONFIRM_WORD = "SVUOTA";

const ACTIONS = [
  {
    key: "demo", loadDemo: true, icon: RotateCcw, label: "Svuota e ricarica demo",
    title: "Svuota e ricarica i dati demo",
    desc: "Cancella tutti i dati e carica operai, cantieri, mezzi e assegnazioni di esempio. Gli account demo vengono riattivati.",
  },
  {
    key: "empty", loadDemo: false, icon: Trash2, label: "Svuota database",
    title: "Svuota completamente il database",
    desc: "Cancella tutti i dati e lascia l'app vuota, pronta per inserire o importare i dati reali.",
  },
];

function ResetDialog({ action, onClose }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await api.post("/admin/database/reset", { confirm: text, load_demo: action.loadDemo });
      toast.success(action.loadDemo ? "✓ Database svuotato e dati demo caricati" : "✓ Database svuotato");
      setTimeout(() => window.location.assign("/dashboard"), 800);
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent data-testid={`db-reset-dialog-${action.key}`}>
        <DialogHeader>
          <DialogTitle>{action.title}</DialogTitle>
          <DialogDescription>{action.desc} L'operazione non si può annullare. Il tuo account resta invariato.</DialogDescription>
        </DialogHeader>
        <label className="text-sm" htmlFor="db-reset-confirm">Scrivi <span className="font-mono font-bold text-red-400">{CONFIRM_WORD}</span> per confermare</label>
        <Input id="db-reset-confirm" value={text} onChange={(e) => setText(e.target.value)} autoComplete="off" data-testid="db-reset-confirm-input" />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={busy} data-testid="db-reset-cancel-btn">Annulla</Button>
          <Button variant="destructive" onClick={run} disabled={busy || text !== CONFIRM_WORD} data-testid="db-reset-submit-btn">
            {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}{action.label}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

function ActionRow({ action, onPick }) {
  const Icon = action.icon;
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3 py-4 border-b border-red-900/40 last:border-0">
      <div className="flex-1">
        <div className="font-semibold">{action.title}</div>
        <div className="text-sm text-muted-foreground">{action.desc}</div>
      </div>
      <Button variant="destructive" onClick={() => onPick(action)} data-testid={`db-reset-${action.key}-btn`}><Icon className="h-4 w-4 mr-2" />{action.label}</Button>
    </div>
  );
}

export default function DatabaseReset() {
  const [action, setAction] = useState(null);
  return (
    <section className="surface p-5 border-red-900/60" data-testid="db-reset-panel">
      <div className="flex items-center gap-2 mb-1"><DatabaseZap className="h-5 w-5 text-red-400" /><h2 className="text-lg font-semibold">Zona pericolosa</h2></div>
      <p className="text-sm text-muted-foreground">Operazioni irreversibili su tutti i dati dell'app: operai, cantieri, mezzi, assegnazioni, documenti, utenti e registri.</p>
      {ACTIONS.map((a) => <ActionRow key={a.key} action={a} onPick={setAction} />)}
      {action && <ResetDialog key={action.key} action={action} onClose={() => setAction(null)} />}
    </section>
  );
}
